module.exports = __webpack_public_path__ + "img/shouzhi.f2ce1f5e.png";